import script from "./addChannel.vue?vue&type=script&setup=true&lang=ts"
export * from "./addChannel.vue?vue&type=script&setup=true&lang=ts"

import "./addChannel.vue?vue&type=style&index=0&id=53783133&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53783133"]])

export default __exports__